import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { getStaticImageUrl, SOURCES } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';
import { PLACEHOLDER_IMAGE_SRC } from 'site-modules/canvas/constants/canvas';
import { Image } from 'site-modules/shared/components/image/image';

import './markdown-image.scss';

export function MarkdownImage({ tag: Tag = 'span', className = 'mb-0', elementRef, src, alt }) {
  const [isLoaded, setLoaded] = useToggle(false, { limit: 1 });

  return (
    <Tag
      ref={elementRef}
      className={classnames('markdown-image no-animation d-flex', className, { loading: !isLoaded })}
    >
      {src !== PLACEHOLDER_IMAGE_SRC && (
        <Image
          className={classnames('rounded-12 w-100', { 'd-none': !isLoaded })}
          imageId={src}
          title={alt}
          alt={alt}
          errorImage={getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN)}
          source={SOURCES.MEDIA}
          onLoad={setLoaded}
        />
      )}
    </Tag>
  );
}

MarkdownImage.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  className: PropTypes.string,
  elementRef: PropTypes.shape({}),
  src: PropTypes.string,
  alt: PropTypes.string,
};
